(function () {
  var initialized = new WeakSet();

  function initArchive819(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var lastModalTrigger = null;
    var imageModal = root.querySelector('[data-image-modal]');
    var reviewsModal = root.querySelector('[data-reviews-modal]');

    function openModal(modal, trigger) {
      if (!modal) return;
      lastModalTrigger = trigger || null;
      modal.hidden = false;
      document.body.classList.add('archive-modal-open');
      var closeButton = modal.querySelector('[data-close-modal]');
      if (closeButton) closeButton.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      if (!root.querySelector('.modal-backdrop:not([hidden])')) {
        document.body.classList.remove('archive-modal-open');
      }
      if (lastModalTrigger) lastModalTrigger.focus();
    }

    var imageTrigger = root.querySelector('[data-open-image]');
    var reviewsTrigger = root.querySelector('[data-open-reviews]');
    if (imageTrigger) imageTrigger.addEventListener('click', function () { openModal(imageModal, imageTrigger); });
    if (reviewsTrigger) reviewsTrigger.addEventListener('click', function () { openModal(reviewsModal, reviewsTrigger); });

    root.querySelectorAll('[data-close-modal]').forEach(function (button) {
      button.addEventListener('click', function () { closeModal(button.closest('.modal-backdrop')); });
    });
    root.querySelectorAll('.modal-backdrop').forEach(function (backdrop) {
      backdrop.addEventListener('click', function (event) {
        if (event.target === backdrop) closeModal(backdrop);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openModalElement = root.querySelector('.modal-backdrop:not([hidden])');
      if (openModalElement) closeModal(openModalElement);
    });

    var viewport = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    var previous = root.querySelector('[data-carousel-previous]');
    var next = root.querySelector('[data-carousel-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var active = 0;

    function updateCarousel() {
      if (!viewport || !track || !cards.length) return;
      var mobile = window.matchMedia('(max-width: 768px)').matches;
      var max = Math.max(0, cards.length - (mobile ? 1 : 2));
      active = Math.min(active, max);
      var step = mobile ? viewport.clientWidth + 16 : viewport.clientWidth / 2 + 12;
      track.style.transform = 'translate3d(-' + active * step + 'px, 0, 0)';
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === max;
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === active);
      });
    }

    if (previous) previous.addEventListener('click', function () { active = Math.max(0, active - 1); updateCarousel(); });
    if (next) next.addEventListener('click', function () { active += 1; updateCarousel(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { active = Number(dot.getAttribute('data-carousel-dot')) || 0; updateCarousel(); });
    });
    if (viewport && window.ResizeObserver) new ResizeObserver(updateCarousel).observe(viewport);
    window.addEventListener('resize', updateCarousel);
    updateCarousel();

    root.querySelectorAll('[data-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.faq-item');
        var willOpen = !item.classList.contains('is-open');
        root.querySelectorAll('.faq-item').forEach(function (other) {
          other.classList.remove('is-open');
          var otherButton = other.querySelector('[data-faq-button]');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var variantSelect = root.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var price = root.querySelector('[data-product-price]');
        var compare = root.querySelector('[data-compare-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-archive819-section]').forEach(initArchive819);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
